<template>
  <a-modal
    :title="$t('timeConfig.authDeviceTitle')"
    :okText="$t('timeConfig.saveBtn')"
    :cancelText="$t('timeConfig.cancelBtn')"
    :visible="true"
    :maskClosable="false"
    :confirm-loading="confirmLoading"
    :width="600" 
    :bodyStyle="{ maxHeight: '600px', 'overflow-y': 'auto', 'padding-top': '0' }"
    @ok="handleConfirm"
    @cancel="handleCancel"
  > 
    <div v-if="!treeData.length" class="spin-warp">
      <a-spin size="large" tip="Loading..." />
    </div>
    <div v-else>
      <h4 class="tree-tips">
        <span style="margin-right: 10px;">总共 <span style="color:#1890FF;font-size:15px;">{{devicesCount}}</span> 台门禁设备</span>
        <span>已选中 <span style="color:#1890FF;font-size:15px;">{{checkedDevices.length}}</span> 台</span>
      </h4>
    
      <a-tree
        :tree-data="treeData" 
        show-icon 
        checkable 
        :selectable="false"
        :defaultExpandedKeys="[treeData[0].key]"
        :checkedKeys="checkedNodes"
        @check="handleTreeNodeCheck"
      >
        <a-icon slot="bank" type="bank" />
        <a-icon slot="android" type="android" />
        <template slot="title" slot-scope="{ title }">
          <span>{{title}}</span>
        </template>
      </a-tree>
    </div>
  </a-modal>
</template>

<script>
import { 
  getDevicesTree,
  setTimeConfigAuth
} from '@/api/timeConfig';

export default {
  name: 'AuthTreeModal',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      confirmLoading: false,
      treeData: [],
      checkedNodes: [],
      checkedDevices: [],
      devicesCount: 0
    }
  },
  computed: {},
  mounted() {
    this.getDevicesTreeData()
  },
  methods: {
    async getDevicesTreeData() {
      const { data } = await getDevicesTree(this.id)
      const treeData = this.createTreeData(data.collection)
      this.treeData = treeData
    },
    createTreeData(data) {
      let treeData = []
      treeData = data.map(item => {
        // 值处理组织节点，设备节点直接返回
        if (item.type === 'device') return item
        // 处理组织节点中存在的设备节点
        let deviceNodes = []
        if (item.devices && item.devices.length) {
          // 标记总设备数
          this.devicesCount += item.devices.length
          deviceNodes = item.devices.map(device => {
            // 记录已勾选的设备
            if (device.isCheck) {
              this.checkedNodes.push(device.id + ':device')
              this.checkedDevices.push(device.id)
            }

            return {
              key: device.id + ':device',
              title: device.deviceName,
              type: 'device',
              slots: { icon: 'android' },
              scopedSlots: { title: 'title' }
            }
          })
        }
        // 处理组织节点
        const node = {
          key: item.id + ':org',
          title: item.name,
          type: 'org',
          // 将当前组织节点的子组织节点与该节点下的设备节点合并，再存入其 children 中
          children: [].concat(item.children || [], deviceNodes),
          slots: { icon: 'bank' },
          scopedSlots: { title: 'title' }
        }
        // 递归处理组织节点的子节点
        if (node.children && node.children.length) {
          node.children = this.createTreeData(node.children)
        }

        return node
      })
      return treeData
    },

    handleTreeNodeCheck(selectedKeys, info) {
      this.checkedNodes = selectedKeys
      
      const devices = []
      this.checkedNodes.forEach(key => {
        const [id, type] = key.split(':')
        if (type === 'device') devices.push(id)
      })
      this.checkedDevices = devices
    },

    async handleConfirm() {
      try {
        this.confirmLoading = true
        await setTimeConfigAuth({
          durationId: this.id,
          deviceIds: this.checkedDevices
        })
        this.$notification.success({ message: this.$t('timeConfig.authDevicesSuccess'), duration: 2 })
        this.confirmLoading = true
        this.$emit('close', { refreshList: true })
      } catch (error) {
        this.confirmLoading = true
      }
    },
    handleCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.spin-warp{
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tree-tips{
  margin: 0;
  padding: 10px 0;
  color: #6c6c6c;
}
</style>
